'use client';

import { RegistrationTracker } from '@/components/analytics/RegistrationTracker';
import ActionButton from '@/components/form/ActionButton/ActionButton';
import { OAUTH_PROVIDER } from '@/constants';
import { swal } from '@/lib/sweetalert';
import layoutStyles from '@/styles/modules/layout.module.scss';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { useState } from 'react';

const SignInForm = ({
  callbackUrl = '/',
  daccountRegisterUrl = null,
}: {
  callbackUrl: string;
  daccountRegisterUrl: string | null;
}) => {
  const [showRegistrationTracking, setShowRegistrationTracking] = useState(false);

  const daccountRedirect = async () => {
    const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;
    const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL;
    const serviceId = process.env.NEXT_PUBLIC_SERVICE_ID;
    if (!baseUrl || !apiBaseUrl || !serviceId) {
      return;
    }
    const encodedCallbackUrl = encodeURIComponent(`${baseUrl}/auth/signup?complete_callback_url=${callbackUrl}`);
    const encodedCancelUrl = encodeURIComponent(`${baseUrl}/auth/signin`);
    window.location.href = `${apiBaseUrl}/oauth/v1/${OAUTH_PROVIDER.daccount.value}/redirect?oem_service_id=${serviceId}&callback_url=${encodedCallbackUrl}&cancel_url=${encodedCancelUrl}`;
  };

  const handleSignupClick = async () => {
    // 会員登録開始トラッキング
    RegistrationTracker.trackRegistrationStart();

    // 外部サイトへの遷移トラッキング
    RegistrationTracker.trackExternalRedirect(callbackUrl);

    // 離脱検知を開始
    setShowRegistrationTracking(true);

    // 外部サイトに遷移
    await daccountRedirect();
  };

  const handleDaccountRegisterClick = () => {
    if (daccountRegisterUrl) {
      window.location.href = daccountRegisterUrl;
    } else {
      swal.messages({ messages: ['dアカウント登録URLの取得に失敗しました'] });
    }
  };

  return (
    <>
      {/* 会員登録フロー離脱検知 */}
      {showRegistrationTracking}
      <div className={`${layoutStyles.centeredBtnWrapper} ${utilsStyles.mtSmall}`}>
        <div>
          <div className={`${utilsStyles.descriptionContainer} ${utilsStyles.textSmall}`}>
            ご利用には株式会社NTTドコモが提供している「dアカウント」と
            <br />
            フォッグ株式会社が提供しているButterflyの会員であることを要します。
            <br />
            <br />
            ぴっくじを初めてご利用する方は、ButterflyIDの
            <a
              href={`${process.env.NEXT_PUBLIC_MAIN_URL}/terms`}
              className={utilsStyles.textLink}
              target='_blank'
              rel='noreferrer'
            >
              利用規約
            </a>
            と
            <a href='/policy' className={utilsStyles.textLink}>
              個人情報の取り扱い
            </a>
            に同意の上、下記のボタンより登録をお願いします。
          </div>
        </div>
        <ActionButton onClick={handleSignupClick} color='primary'>
          dアカウントログイン
        </ActionButton>
      </div>
      <hr className={`${utilsStyles.hr} ${utilsStyles.mtMedium}`} />
      <div className={`${layoutStyles.centeredBtnWrapper} ${utilsStyles.mtSmall}`}>
        <ActionButton onClick={handleDaccountRegisterClick} color='primary'>
          dアカウント新規会員登録
        </ActionButton>
      </div>
    </>
  );
};
export default SignInForm;
